import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './BackToStreamButton';
import { exitDuperbrowse } from '../redux/actionCreators';
import { getDuperbrowseStreamParent, getCurrentItem } from '../redux/selectors';

export type StateProps = Pick<Props, 'parent' | 'currentItem'>;
export type DispatchProps = Pick<Props, 'exitDuperbrowse'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  parent: getDuperbrowseStreamParent(state),
  currentItem: getCurrentItem(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  exitDuperbrowse,
};

export default connect(mapStateToProps, mapDispatchToProps);
